<template>
     <div class="img_style_1">
           <template v-if="imageUrl">
             <img class="item_img" :data-src="imageUrl" alt="24order.no" uk-img />
           </template>
           <template v-else>
            <img class="item_img" :data-src="get_setting_app.logo" alt="24order.no" uk-img />
           </template>
          </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
   name:'block_img',
   props:['imageUrl'],
      computed:{
    ...mapGetters({
        get_setting_app:'get_setting_app',
    })
    } ,
}
</script>

